import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_24db64a8 from 'nuxt_plugin_sentryserver_24db64a8' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_f04e47b8 from 'nuxt_plugin_sentryclient_f04e47b8' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_gtm_fa13d284 from 'nuxt_plugin_gtm_fa13d284' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_plugin_3ab74f92 from 'nuxt_plugin_plugin_3ab74f92' // Source: ./amp/plugin.js (mode: 'all')
import nuxt_plugin_webfontloader_ff3c5830 from 'nuxt_plugin_webfontloader_ff3c5830' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_axios_023e1430 from 'nuxt_plugin_axios_023e1430' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vueqrcode_09435728 from 'nuxt_plugin_vueqrcode_09435728' // Source: ../plugins/vue-qrcode.js (mode: 'client')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'client')
import nuxt_plugin_notyf_52769a4d from 'nuxt_plugin_notyf_52769a4d' // Source: ../plugins/notyf.js (mode: 'client')
import nuxt_plugin_lazySizes_7c7e53a2 from 'nuxt_plugin_lazySizes_7c7e53a2' // Source: ../plugins/lazySizes.js (mode: 'client')
import nuxt_plugin_routingEach_11ab4da6 from 'nuxt_plugin_routingEach_11ab4da6' // Source: ../plugins/routingEach.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"CTWANT","meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=3, user-scalable=yes"},{"hid":"description","name":"description","content":"CTWANT為一綜合型新聞網站，由王道旺台媒體股份有限公司於2019年7月創建，涵蓋政治、財經、社會、娛樂、漂亮、生活、國際、影音等八大類別，提供獨家新聞及豐富內容，未來將企劃更多精采專題，讓您一手掌握最新資訊！"},{"hid":"keywords","name":"keywords","content":"CTWANT,時報周刊,周刊王,政治,社會"},{"hid":"ogUrl","property":"og:url","content":"https:\u002F\u002Fwww.ctwant.com"},{"hid":"ogType","property":"og:type","content":"website"},{"hid":"ogTitle","property":"og:title","content":"CTWANT"},{"hid":"ogImage","property":"og:image","content":"https:\u002F\u002Fstatic.ctwant.com\u002Fimages\u002Fdist\u002Fctwant.jpg"},{"hid":"ogImageWidth","property":"og:image:width","content":"858"},{"hid":"ogImageHeight","property":"og:image:height","content":"452"},{"hid":"ogDescription","property":"og:description","content":"CTWANT為一綜合型新聞網站，由王道旺台媒體股份有限公司於2019年7月創建，涵蓋政治、財經、社會、娛樂、漂亮、生活、國際、影音等八大類別，提供獨家新聞及豐富內容，未來將企劃更多精采專題，讓您一手掌握最新資訊！"},{"hid":"fbPages","property":"fb:pages","content":"105483392827926"},{"hid":"charset","charset":"utf-8"}],"link":[{"hid":"alternate","rel":"alternate","hreflang":"zh-Hant","href":"https:\u002F\u002Fwww.ctwant.com"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Fstatic.ctwant.com\u002Fimages\u002Fdist\u002Fapple-touch-icon.png"},{"hid":"font-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"font-preload","rel":"preload","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Noto+Sans+TC:wght@300;400;500;700&display=swap"}],"script":[{"src":"https:\u002F\u002Fsecurepubads.g.doubleclick.net\u002Ftag\u002Fjs\u002Fgpt.js","defer":true},{"src":"https:\u002F\u002Fwww.gstatic.com\u002Ffirebasejs\u002F7.13.2\u002Ffirebase-app.js","defer":true},{"src":"https:\u002F\u002Fwww.gstatic.com\u002Ffirebasejs\u002F7.13.2\u002Ffirebase-messaging.js","defer":true},{"src":"https:\u002F\u002Fwww.instagram.com\u002Fembed.js","defer":true},{"src":"https:\u002F\u002Fwww.youtube.com\u002Fiframe_api"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NF95NZR')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NF95NZR&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_24db64a8 === 'function') {
    await nuxt_plugin_sentryserver_24db64a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_f04e47b8 === 'function') {
    await nuxt_plugin_sentryclient_f04e47b8(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_fa13d284 === 'function') {
    await nuxt_plugin_gtm_fa13d284(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3ab74f92 === 'function') {
    await nuxt_plugin_plugin_3ab74f92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_ff3c5830 === 'function') {
    await nuxt_plugin_webfontloader_ff3c5830(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_023e1430 === 'function') {
    await nuxt_plugin_axios_023e1430(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueqrcode_09435728 === 'function') {
    await nuxt_plugin_vueqrcode_09435728(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notyf_52769a4d === 'function') {
    await nuxt_plugin_notyf_52769a4d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazySizes_7c7e53a2 === 'function') {
    await nuxt_plugin_lazySizes_7c7e53a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routingEach_11ab4da6 === 'function') {
    await nuxt_plugin_routingEach_11ab4da6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
